var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DiscountManager, OrderItem } from 'aigens-ng-core';
import { ChangeDetectorRef, Injector, OnInit } from '@angular/core';
import { RouteTable } from '../../core/route-table';
import { SdkApplepayService } from '../../core/services/sdk-applepay-service';
import { SdkNativeOepayService } from '../../core/services/sdk-native-oepay-service';
import { SdkAlipayHKService } from '../../core/services/sdk-alipay-hk-service';
import { getDeliveryDelayTime, getPickupDelayTime } from '../../shared/utilities/checkFormatTool';
import { ModifierDialog } from '../../dialogs/modifier/modifier';
import { SdkWeChatPayService } from '../../core/services/sdk-wechat-pay-service';
import { MultiStepComboPage } from '../item/multi-step-combo/multi-step-combo-page.component';
import { getSetLayout } from '../../shared/utilities/layout-helper';
import { DatePipe } from '@angular/common';
import { BaseCartPage } from '../../core/base/base-cart-page';
import { ComboPage } from '../item/combo-page/combo-page';
// Deprecated, please use cart-scroll-page
var CartPage = /** @class */ (function (_super) {
    __extends(CartPage, _super);
    // tslint:disable-next-line: max-line-length
    function CartPage(discountManager, sdkWeChatPayService, sdkAlipayHKService, sdkNativeOepayService, sdkApplePayService, injector, datePipe, cd) {
        var _this_1 = _super.call(this, injector) || this;
        _this_1.discountManager = discountManager;
        _this_1.sdkWeChatPayService = sdkWeChatPayService;
        _this_1.sdkAlipayHKService = sdkAlipayHKService;
        _this_1.sdkNativeOepayService = sdkNativeOepayService;
        _this_1.sdkApplePayService = sdkApplePayService;
        _this_1.datePipe = datePipe;
        _this_1.cd = cd;
        _this_1.unlocks = [];
        _this_1.showedBox = false;
        CartPage._this = _this_1;
        return _this_1;
    }
    CartPage.prototype.isSet = function (oi) {
        return OrderItem.isSet(oi);
    };
    CartPage.prototype.modifierClicked = function (oi) {
        var _this_1 = this;
        var oiId = oi.categoryId;
        var store = this.orderManager.getStore(oi.storeId);
        var nowCategory = oi.categoryType !== 'recommendation' ? store.categories.filter(function (category) { return category.id === oiId; }) : [store.menu.recommendation];
        var oiItemId = oi.groups[0].items[0].id;
        // tslint:disable-next-line:no-var-keyword
        var nowItem = nowCategory[0].groups[0].items.filter(function (item) { return item.id === oiItemId; });
        // tslint:disable-next-line:no-var-keyword
        var groups = nowCategory[0].groups, groups = groups && groups.filter(function (group) {
            return _this_1.menuManager.isAvailableGroup(store, nowCategory[0], group, oi.takeout, Date.now(), false);
        });
        this.refreshAnimation(true);
        this.add(nowItem[0], groups[0], oi, false);
    };
    CartPage.prototype.handlingModifier = function (oi, item, itemMap, addHandler, notAddHandler, showLastOne) {
        if (showLastOne === void 0) { showLastOne = false; }
        var group = oi.groups[0];
        if (true) {
            this.presentModifierPopup(this.orderManager.getStore(oi.storeId), oi, group, itemMap, ModifierDialog, function (confirm) {
                if (confirm && confirm['data']) {
                    addHandler();
                }
            }, showLastOne);
        }
        else {
            addHandler();
        }
    };
    CartPage.prototype.removeClicked = function (item) {
        console.log('remove clicked');
        this.orderManager.minusItem(item, true);
    };
    CartPage.prototype.presentModifierPopup = function (store, orderItem, group, itemMap, page, handler, showLastOne) {
        return __awaiter(this, void 0, void 0, function () {
            var input, modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        input = { store: store, orderitem: orderItem, group: group, itemMap: itemMap, side: true };
                        if (showLastOne) {
                            input['showLastOne'] = showLastOne;
                        }
                        return [4 /*yield*/, this.modalController.create({
                                component: page,
                                componentProps: input,
                                animated: true,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: 'modal-largescreen modifier-modal side-modifier'
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then(function (confirm) {
                            if (handler) {
                                handler(confirm);
                            }
                        });
                        modal.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartPage.prototype.paymentHandling = function () {
        var _this_1 = this;
        if (this.isPointFullPay) {
            var order_ = this.genOrder(this.orderManager.getOrder());
            console.log('PointFullPay order', order_);
            this.loading(true);
            this.orderService.postOrderWithPaymentObject(order_, this.pointPayment).subscribe(function (o) {
                _this_1.loading(false);
                var order = o['data'];
                _this_1.loading(false);
                _this_1.popToRoot().then(function (data) {
                    if (_this_1.getNavParams('hideHistory')) {
                        _this_1.orderService.clear();
                    }
                    else {
                        _this_1.pushByName('OrderStatusPage', {
                            order: order,
                            status: (order && order['paid']) ? 'success' : 'fail'
                        }).then(function () {
                            _this_1.orderService.clear();
                        });
                    }
                });
            }, function (err) {
                _this_1.loading(false);
                _this_1.showError(err);
            });
        }
        else {
            var payMethods = this.getPaymentMethods(this.payments);
            var size = Object.keys(payMethods).length;
            var hideHistory_1 = this.settings ? this.settings.hideHistory : false;
            console.log('size', size);
            var payLater = this.orderManager.mode === 'byod' || this.orderManager.mode === 'prekiosk';
            if (!payLater && this.isPointFullPay) {
                for (var _i = 0, _a = this.payments; _i < _a.length; _i++) {
                    var payment = _a[_i];
                    if (payment['method'] === 'point') {
                        return;
                    }
                }
            }
            if (size >= 1 && !payLater) {
                if (this.sdkNativeOepayService.isAvailable() && payMethods['oepay']) {
                    this.pushByName('OepayPaymentPage', {
                        order: this.orderManager.getOrder(),
                        payment: payMethods['oepay'],
                        hideHistory: hideHistory_1
                    });
                }
                else {
                    this.paymentConfirmAlert(payMethods);
                }
            }
            else {
                this.cartService.lockSharingCart().then(function (data) {
                    console.log('on lock callback', data);
                    if (!data || !data['committed']) {
                        _this_1.toastController.create({
                            message: ' someone is submitting current order, please wait',
                            duration: 2000,
                            position: 'middle'
                        }).then(function (modal) {
                            modal.present();
                        });
                        return;
                    }
                    else {
                        _this_1.loading(true);
                        var order = _this_1.orderManager.getOrder();
                        if (_this_1.orderManager.mode === 'prekiosk') {
                            var endTime = new Date();
                            endTime.setHours(Number(_this_1.orderService.currentPeriod.endTime.split(':')[0]), Number(_this_1.orderService.currentPeriod.endTime.split(':')[1]), 0, 0);
                            order.expire = endTime.getTime();
                        }
                        _this_1.orderService.postOrder(_this_1.orderManager.getOrder()).subscribe(function (order) {
                            _this_1.loading(false);
                            console.log('order', order);
                            // this.orderService.order = order;
                            var hasNewOffer = false;
                            if (order.newOffers && order.newOffers.length > 0) {
                                hasNewOffer = true;
                            }
                            _this_1.cartService.unlockSharingCart();
                            // this.popToRoot();
                            _this_1.navController.setDirection('root');
                            if (hideHistory_1) {
                                _this_1.pushByUrl(RouteTable['OrderStatusPage'], { status: 'success', hideHistory: true }, {});
                            }
                            else {
                                if (order.type === 'prekiosk') {
                                    _this_1.pushByUrl(RouteTable['OrderStatusPreKioskPage'], {
                                        order: order,
                                        fromCart: true,
                                        store: _this_1.orderManager.store
                                    }).then(function () {
                                        _this_1.orderService.clear();
                                        _this_1.orderManager.clear();
                                        // if (this.getNavParams('fromSplash')) {
                                        //     this.orderManager.clear();
                                        // }
                                    });
                                }
                                else if (order.type === 'byod') {
                                    _this_1.pushByUrl(RouteTable['OrderStatusPage'], {
                                        status: 'success',
                                        storeId: _this_1.orderManager.store.id,
                                        spot: _this_1.orderService.spot,
                                        key: _this_1.orderService.session,
                                        hideHistory: false,
                                        hasNewOffer: hasNewOffer,
                                        order: order
                                    }, {}).then(function () {
                                        _this_1.orderService.clear();
                                        _this_1.orderManager.clear();
                                    });
                                }
                            }
                        }, function (err) {
                            _this_1.loading(false);
                            if (err.status === 599) {
                                var alert_1 = _this_1.showAlert(err.status, err['_body'], [{
                                        text: _this_1.t.instant('buttons.ok'),
                                        handler: function () {
                                            _this_1.pushByName('ByodSummaryPage');
                                        }
                                    }]);
                            }
                            else {
                                _this_1.showError(err);
                            }
                        }, function () {
                            _this_1.cartService.unlockSharingCart();
                        });
                    }
                }, function () {
                });
            }
        }
    };
    CartPage.prototype.paymentConfirmAlert = function (payMethods) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // const alert = await this.alertController.create({
                //     header: this.t.instant('pages.cart.confirm'),
                //     buttons: [
                //         {
                //             text: this.t.instant('buttons.cancel'),
                //             role: 'cancel',
                //             handler: data => {
                //             }
                //         },
                //         {
                //             text: this.t.instant('buttons.ok'),
                //             handler: data => {
                //                 this.presentPaymentMethod(payMethods);
                //             }
                //         }
                //     ],
                //         cssClass: "AQA-confirmPayment"
                // });
                // alert.present();
                this.presentPaymentMethod(payMethods);
                return [2 /*return*/];
            });
        });
    };
    CartPage.prototype.selectUpSelling = function (item) {
        var _this_1 = this;
        if (item.groupIds.length > 0) {
            var page = getSetLayout(this.orderManager.store.menu.setLayout);
            var groups_1 = [];
            item.groupIds.forEach(function (groupId) {
                groups_1.push(_this_1.orderManager.store.menu['gmap'][groupId]);
            });
            item.groups = groups_1;
            // this.pushByUrl(page, {
            //     store: this.orderManager.store,
            //     category: this.upSellItemCategory,
            //     groups: [this.upSellItemGroup],
            //     item: item,
            //     upSelling: true
            // }, {relativeTo: this.route});
            var params = {
                store: this.orderManager.store,
                category: this.upSellItemCategory,
                groups: [this.upSellItemGroup],
                item: item,
                upSelling: true
            };
            this.navToAssignLayoutItems(page === 'MultiStepComboPage' ? MultiStepComboPage : ComboPage, page, params);
        }
        else {
            this.orderManager.addSingleItem(this.upSellItemCategory, this.upSellItemGroup, item, false);
            this.applyPromotion(false);
        }
        this.checkModifiableItems();
    };
    CartPage.prototype.addClicked = function (oi) {
        this.googleAnalyticEventTrack('add', 'open edit');
        // this.orderService.addExistingOrderItem(oi);
        if (this.checkStoreMaxItem()) {
            this.showStoreMaxItemAlert();
            return;
        }
        if (oi.categoryType === 'unlock') {
            return;
        }
        this.refreshAnimation(true);
        this.orderManager.addExistingOrderItem(oi);
        this.applyPromotion();
        this.cd.detectChanges();
    };
    CartPage.prototype.duplicateClicked = function (oi) {
        // this.orderService.addOrderItem(oi);
        // this.orderService.addSet(oi.category, oi.groups, oi.items);
        // var newOi = this.orderService.copyOrderItem(oi);
        // this.orderService.addOrderItem(newOi);
        this.googleAnalyticEventTrack('duplicate', 'open edit');
        if (this.checkStoreMaxItem()) {
            this.showStoreMaxItemAlert();
            return;
        }
        this.refreshAnimation(true);
        this.orderManager.duplicateOrderItem(oi);
        this.applyPromotion();
    };
    CartPage.prototype.deleteClicked = function (oi) {
        this.googleAnalyticEventTrack('delete', 'open edit');
        // this.orderService.minusOrderItem(oi);
        this.refreshAnimation(true);
        this.orderManager.minusOrderItem(oi);
        // TODO: this.navController.canGoBack()=> this.stackController.canGoBack(0)?
        if (this.orderManager.isEmpty()) {
            this.navigationService.popPage();
        }
        else {
            this.applyPromotion();
        }
    };
    CartPage.prototype.showPromoGift = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            var _this_1 = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            header: this.t.instant('pages.cart.input-discount-code'),
                            inputs: [{
                                    name: 'discountCode',
                                    type: 'text',
                                    label: this.t.instant('pages.cart.input-discount-code'),
                                    value: ''
                                }],
                            buttons: [
                                {
                                    text: this.t.instant('buttons.cancel'),
                                    handler: function () {
                                    }
                                },
                                {
                                    text: this.t.instant('buttons.ok'),
                                    handler: function (_a) {
                                        var discountCode = _a.discountCode;
                                        _this_1.discountCode = discountCode;
                                        if (_this_1.applyDiscountCode(discountCode)) {
                                            _this_1.showToast(_this_1.t.instant('pages.cart.discount-code-fail'), 2000, 'top', 'error-alert');
                                            return false;
                                        }
                                    }
                                }
                            ]
                        })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartPage.prototype.minusClicked = function (oi) {
        this.googleAnalyticEventTrack('minus', 'open edit');
        // this.orderService.minusOrderItem(oi);
        this.orderManager.minusOrderItem(oi);
        this.refreshAnimation(true);
        // TODO: this.navController.canGoBack()=> this.stackController.canGoBack(0)?
        if (this.orderManager.isEmpty()) {
            this.orderService.clearPromoCodeGift();
            this.orderManager.setDiscountCode(''); // 清空discountCode
            this.navigationService.popPage();
        }
        else {
            this.applyPromotion();
        }
    };
    CartPage.prototype.editClicked = function (oi) {
        return __awaiter(this, void 0, void 0, function () {
            var category, groups, mainItem, page, params;
            return __generator(this, function (_a) {
                this.refreshAnimation(true);
                console.log('edit clicked', oi);
                this.googleAnalyticEventTrack('edit', 'open edit');
                category = oi.category;
                groups = category.groups;
                mainItem = oi.items[0].origin;
                page = getSetLayout(this.orderManager.store.menu.setLayout);
                params = {
                    store: this.orderManager.store,
                    edit: oi,
                    category: category,
                    groups: groups,
                    item: mainItem
                };
                this.navToAssignLayoutItems(page === 'MultiStepComboPage' ? MultiStepComboPage : ComboPage, page, params);
                return [2 /*return*/];
            });
        });
    };
    CartPage.prototype.getDefaultTimeLabel = function () {
        var timeDelay;
        if (this.orderManager.mode !== 'delivery') {
            timeDelay = getPickupDelayTime(this.orderManager.store);
        }
        else {
            timeDelay = getDeliveryDelayTime(this.orderManager.store);
        }
        return timeDelay > 0 ? (timeDelay + this.t.instant('global.minutes-later')) : this.t.instant('global.eat-now');
    };
    CartPage.prototype.isValidPickupTime = function () {
        if (!this.settings.pickupTime) {
            return true;
        }
        var currentTime = new Date().getTime();
        var res = this.getDefaultTimeLabel();
        if (this.pickedTimeNum > currentTime || this.timelabel === res) {
            return true;
        }
        else {
            this.orderService.pickUpLabel = null;
            if (!this.orderService.isCourt) {
                this.orderService.pickUpTime = null;
            } // 如果是court pickupTime采取页面开始时选择的Time
            this.settingPickupTimeDisplay();
            this.settingPickupTime();
            this.showAlert('', this.t.instant('global.pick-up-time-invalid'));
            return false;
        }
    };
    CartPage.prototype.pageName = function () {
        return '/cart';
    };
    CartPage.prototype.refreshAnimation = function (initPoint) {
        console.log('checked the button');
        // let order_ = this.genOrder(this.orderManager.getOrder());
        // if (this.userTotalPoints * this.getCrmPointRatio() >= Number(order_.grandTotal)) { // 用户积分 >= 订单价格
        //     this.selectedPoint = Number(order_.grandTotal) / this.getCrmPointRatio();
        //     this.isPointFullPay = true;
        // } else if (this.userTotalPoints * this.getCrmPointRatio() < Number(order_.grandTotal)) {
        //     this.selectedPoint = this.userTotalPoints;
        //     this.isPointFullPay = false;
        // }
        // this.isPayByPoint = !(initPoint || this.isPayByPoint);
        if (this.isPayByPoint) {
            this.selectedPoint = 0;
        }
        else {
            this.selectedPoint = this.points[this.points.length - 1];
        }
        this.isPayByPoint = !this.isPayByPoint;
        this.orderManager.order.usedPoints = this.selectedPoint;
        this.orderManager.calculate();
    };
    return CartPage;
}(BaseCartPage));
export { CartPage };
